import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=79eed43c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=79eed43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eed43c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79eed43c')) {
      api.createRecord('79eed43c', component.options)
    } else {
      api.reload('79eed43c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=79eed43c&scoped=true&", function () {
      api.rerender('79eed43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G99XWqO4snmF/JS/comp/DocBox.vue"
export default component.exports